import { useState } from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value, onChange, readOnly = false, size = 28 }) => {
  const [hover, setHover] = useState(0);

  return (
    <div
      className="flex items-center gap-2"
      data-testid="testimonial-rating"
      onMouseLeave={() => setHover(0)}
    >
      {[1, 2, 3, 4, 5].map((n) => {
        const active = (hover || value) >= n;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            data-testid={`testimonial-rating-star-${n}`}
            onMouseEnter={() => !readOnly && setHover(n)}
            onClick={() => !readOnly && onChange(n)}
            className="bg-transparent p-0 border-0 cursor-pointer transition-transform duration-200 hover:scale-110 disabled:cursor-default"
            aria-label={`Rate ${n} of 5`}
          >
            <Star
              size={size}
              strokeWidth={1.25}
              className={active ? "fill-[#EEFF00] text-[#EEFF00]" : "fill-none text-[#C8C4BC]"}
            />
          </button>
        );
      })}
      <span className="ml-3 label-eyebrow">
        {value ? `${value} of 5` : "select"}
      </span>
    </div>
  );
};

export default StarRating;
